import React, { Component } from "react";
import FormGroup from "../shared/form/FormGroup";
import { connect } from "react-redux";
import {
  setIsCommValueChanged
} from "../../actions/policy/policyActions";

const mapDispatchToProps = (dispatch) => {
  return {
    setIsCommValueChanged:(Value) => dispatch(setIsCommValueChanged(Value))
  };
};
export class CommPreferenceSection extends Component {

  constructor(props) {
    super(props);
    this.state = {
      CommPreference: [],
    };
    this.PreferenceChanges = this.PreferenceChanges.bind(this);
    this.updatedValue = this.updatedValue.bind(this);
  }

  componentDidMount(){
    let updateCommPrefs=[];
    if(this.props.commPrefsKeys !== undefined && this.props.commPrefsKeys !==null )
      {
        if(this.props.communicationValue !== null && this.props.communicationValue !== undefined){
          this.props.communicationValue.forEach((value)=>{
            let updateValue={
              PersonCommPrefId: value.PersonCommPrefId,
              PersonId: value.PersonId,
              CommunicationPreferenceId: value.CommunicationPreferenceId,
              CommunicationPreferenceName: value.CommunicationPreferenceName,
              CreatedBy: value.CreatedBy,
              LastUpdatedBy: value.LastUpdatedBy,
              SourceSystem: value.SourceSystem,
              SourcePersonId: value.SourcePersonId,
              IsDeleted:false
            };
            updateCommPrefs.push(updateValue);
          });
          this.setState({
            CommPreference:updateCommPrefs
        },()=>{
          this.updateCommPreferences(this.state.CommPreference);
        });
        }
      }
  }

  componentDidUpdate(prevProps){
    if(JSON.stringify(prevProps.communicationValue)!==JSON.stringify(this.props.communicationValue))
    {
      this.updatedValue(this.props.communicationValue);
    }
    }

    updatedValue(communicationValue){
      if(communicationValue!==null)
      {
          this.setState({
            CommPreference:communicationValue,
          });
      }
      else{
        this.setState({
          CommPreference:[],
      });
      }
      
    }


  PreferenceChanges(event,CommunicationPreferenceId){
      this.IsCommValueChanged(true);
      this.props.setIsCommValueChanged(true);
      const commPref = this.state.CommPreference;
      const index = commPref.findIndex(m => m.CommunicationPreferenceId === CommunicationPreferenceId);
      const masterData = this.props.commPrefsKeys.filter((val)=>val.CommunicationPreferenceId === CommunicationPreferenceId);
      const commonId =[1,2,3,5];
      var hasOwnPropertyFlag = false;
      var keytoCheck = 'CommunicationPreferenceId';
      let newValue;
      if(index !== -1)
      {
        let existflag = [];
        if(this.props.communicationValue !== null && this.props.communicationValue !== undefined)
        {
          let originalValue = this.props.communicationValue;
          existflag = originalValue.filter(value=>{
            return value.CommunicationPreferenceId === commPref[index].CommunicationPreferenceId;
          });
        }
        if(existflag.length !== 0 && commPref[index].PersonCommPrefId!==0)
        {
        //Add or delete from existing preference
        commPref[index].IsDeleted = event.target.value==="false"?true:false;
        }
        else{
          // delete entry from existing array(No->yes->No)
          commPref.splice(index,1);
        }
        
        if(commPref[index] !== undefined && commPref[index].hasOwnProperty(keytoCheck)){
          hasOwnPropertyFlag = true;
        }
      }
      else{
        //New entry(No -> yes)
        if(this.props.communicationValue!==null)
        {
            newValue ={
            PersonCommPrefId: 0,
            PersonId: this.state.CommPreference[0].PersonId,
            CommunicationPreferenceId: masterData[0].CommunicationPreferenceId,
            CommunicationPreferenceName: masterData[0].CommunicationPreferenceName,
            CreatedBy: this.props.MemberName,
            LastUpdatedBy: this.props.MemberName,
            SourceSystem: this.state.CommPreference[0].SourceSystem,
            SourcePersonId: this.state.CommPreference[0].SourcePersonId,
            IsDeleted:false
            };
        }
        else{
          newValue ={
            PersonCommPrefId: 0,
            PersonId: "",
            CommunicationPreferenceId: masterData[0].CommunicationPreferenceId,
            CommunicationPreferenceName: masterData[0].CommunicationPreferenceName,
            CreatedBy: this.props.MemberName,
            LastUpdatedBy: this.props.MemberName,
            SourceSystem: "",
            SourcePersonId: "",
            IsDeleted:false
            };
        }
        hasOwnPropertyFlag = true;
        commPref.push(newValue);
      } 
      //Genric code for customized Yes->No & No->yes
      if(hasOwnPropertyFlag && ((commPref[index] !== undefined && commonId.includes(commPref[index].CommunicationPreferenceId)) || (newValue !== undefined && commonId.includes(newValue.CommunicationPreferenceId)))){
        var exceptIds = [];
        var existrecord = [];
        if(index !== -1 ){
          exceptIds = commonId.filter(e=>e !== commPref[index].CommunicationPreferenceId);
          existrecord = commPref.filter(e=> exceptIds.includes(e.CommunicationPreferenceId));
        }else{
          exceptIds = commonId.filter(e=>e !== newValue.CommunicationPreferenceId);
          existrecord = commPref.filter(e=> exceptIds.includes(e.CommunicationPreferenceId));
        }       
        if(existrecord !== undefined && existrecord.length !== 0){
          existrecord.forEach((item,index)=>{
            var idx = commPref.findIndex(e=>e.CommunicationPreferenceId === existrecord[index].CommunicationPreferenceId);
            if(existrecord.length !== 0 && commPref[idx].PersonCommPrefId !== 0){
              commPref[idx].IsDeleted = true;
            }else{
              commPref.splice(idx,1);
            }            
            const yesRadio = document.getElementById("comm"+existrecord[index].CommunicationPreferenceName + "Yes");
            const noRadio = document.getElementById("comm"+existrecord[index].CommunicationPreferenceName + "No"); 
            if (yesRadio.checked) {
              yesRadio.checked = false;
              noRadio.checked = true;       
            }    
          });
        }
      }
      this.setState({
        CommPreference:commPref
      });
      this.updateCommPreferences(this.state.CommPreference);      
  }

  updateCommPreferences(CommPreference) {
    this.props.updateCommPreferences(CommPreference);
  }

  IsCommValueChanged(value)
  {
    this.props.IsCommValueChanged(value);
  }

  render() {
     if(this.props.commPrefsKeys !== undefined && this.props.commPrefsKeys !== null)
     {
     return  this.props.commPrefsKeys.length>0 && this.props.commPrefsKeys.map((informMethod,index) => {
      let communicationOptionValue = false;
      if(this.props.communicationValue !== null && this.props.communicationValue !== undefined){
            communicationOptionValue = this.props.communicationValue.some(val => val.CommunicationPreferenceId === informMethod.CommunicationPreferenceId);
      }
      return (
        <FormGroup
          className={"form-group mt-0"}
          type="yesno"
          id={"comm" + informMethod.CommunicationPreferenceName}
          label={informMethod.CommunicationPreferenceName}
          key={informMethod.CommunicationPreferenceName}
          currentValue={communicationOptionValue}
          onChange={ (event) =>{
            this.PreferenceChanges(event,informMethod.CommunicationPreferenceId);
            return event.target.value === "true"
            ? true
            : event.target.value === "false"
            ? false
            : null;
            }
          }
          Zebrafied={this.props.Zebrafied}
          UseSlider={this.props.UseSlider}
          Subheading={this.props.Subheading}
          PreferenceId={informMethod.CommunicationPreferenceId}
          isMyProfileCommPref = {this.props.isMyProfileCommPref}
        />
      );
    });
  }
  return null;
}
}

export default connect(
  null,
  mapDispatchToProps
)(CommPreferenceSection);